import { z } from "zod";

const PriceSchema = z.object({
  available: z.boolean().default(true),
  id: z.string(),
  amount: z.number(),
  name: z.string(),
  description: z.string(),
  mode: z.enum(["payment", "subscription"]).default("subscription"),
});

const PlanSchema = z.object({
  // Course sites use this stable catalog identifier to map courses to Prices.
  // Subscription sites identify selections by Stripe Price ID and may omit it.
  //
  key: z.string().optional(),
  name: z.string(),
  prices: z.array(PriceSchema),
});

const PricingSchema = z.array(PlanSchema);

export type Plan = z.infer<typeof PlanSchema>;
export type Price = z.infer<typeof PriceSchema>;
export type Pricing = z.infer<typeof PricingSchema>;

export const pricing = (() => {
  try {
    return PricingSchema.parse(
      JSON.parse(z.string().parse(publicEnv.stripePricing)),
    );
  } catch (error) {
    console.error("Invalid STRIPE_PRICING:", error);
    throw new Error("STRIPE_PRICING validation failed.");
  }
})();

const availableSubscriptionPriceIds = new Set(
  pricing.flatMap((plan) =>
    plan.prices
      .filter((price) => price.available && price.mode === "subscription")
      .map((price) => price.id),
  ),
);

// Restrict subscription mutations to the active site's published catalog.
export function isAvailableSubscriptionPriceId(priceId: string) {
  return availableSubscriptionPriceIds.has(priceId);
}
